import WOStatusComponent from "src/Pages/WO/Components/Status/wostatuscomponent";

// The identity strip that sits under a work order's title: number, status, and
// the customer / date / technicians it belongs to. Shared by the service ticket
// preview modal and the service ticket editor so the two never drift.

export const CustomerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#wometa_customer_clip)">
      <path
        d="M11.5 2.66732C11.5 2.4463 11.4121 2.23441 11.2559 2.07812C11.0996 1.92184 10.8877 1.83398 10.6667 1.83398H5.33334C5.11233 1.83398 4.90043 1.92184 4.74415 2.07812C4.58787 2.23441 4.50001 2.4463 4.50001 2.66732V14.1673H11.5V2.66732ZM12.5 14.6673C12.5 14.9435 12.2762 15.1673 12 15.1673H4.00001C3.72387 15.1673 3.50001 14.9435 3.50001 14.6673V2.66732C3.50001 2.18109 3.6933 1.71491 4.03712 1.37109C4.38094 1.02728 4.84711 0.833984 5.33334 0.833984H10.6667C11.1529 0.833984 11.6191 1.02728 11.9629 1.37109C12.3067 1.71491 12.5 2.18109 12.5 2.66732V14.6673Z"
        fill="#5F6477"
      />
      <path
        d="M0.833344 13.334V9.33398C0.833344 8.84775 1.02664 8.38158 1.37045 8.03776C1.71427 7.69394 2.18045 7.50065 2.66668 7.50065H4.00001C4.27615 7.50065 4.50001 7.72451 4.50001 8.00065C4.50001 8.27679 4.27615 8.50065 4.00001 8.50065H2.66668C2.44566 8.50065 2.23376 8.58851 2.07748 8.74479C1.9212 8.90107 1.83334 9.11297 1.83334 9.33398V13.334C1.83334 13.555 1.9212 13.7669 2.07748 13.9232C2.23376 14.0795 2.44566 14.1673 2.66668 14.1673H4.00001C4.27615 14.1673 4.50001 14.3912 4.50001 14.6673C4.50001 14.9435 4.27615 15.1673 4.00001 15.1673H2.66668C2.18045 15.1673 1.71427 14.974 1.37045 14.6302C1.02664 14.2864 0.833344 13.8202 0.833344 13.334Z"
        fill="#5F6477"
      />
      <path
        d="M14.1667 13.334V7.33398C14.1667 7.11297 14.0788 6.90107 13.9225 6.74479C13.7663 6.58851 13.5544 6.50065 13.3333 6.50065H12C11.7239 6.50065 11.5 6.27679 11.5 6.00065C11.5 5.72451 11.7239 5.50065 12 5.50065H13.3333C13.8196 5.50065 14.2858 5.69394 14.6296 6.03776C14.9734 6.38158 15.1667 6.84775 15.1667 7.33398V13.334C15.1667 13.8202 14.9734 14.2864 14.6296 14.6302C14.2858 14.974 13.8196 15.1673 13.3333 15.1673H12C11.7239 15.1673 11.5 14.9435 11.5 14.6673C11.5 14.3912 11.7239 14.1673 12 14.1673H13.3333C13.5544 14.1673 13.7663 14.0795 13.9225 13.9232C14.0788 13.7669 14.1667 13.555 14.1667 13.334Z"
        fill="#5F6477"
      />
      <path
        d="M9.33334 3.50065C9.60949 3.50065 9.83334 3.72451 9.83334 4.00065C9.83334 4.27679 9.60949 4.50065 9.33334 4.50065H6.66668C6.39053 4.50065 6.16668 4.27679 6.16668 4.00065C6.16668 3.72451 6.39053 3.50065 6.66668 3.50065H9.33334Z"
        fill="#5F6477"
      />
      <path
        d="M9.33334 6.16732C9.60949 6.16732 9.83334 6.39117 9.83334 6.66732C9.83334 6.94346 9.60949 7.16732 9.33334 7.16732H6.66668C6.39053 7.16732 6.16668 6.94346 6.16668 6.66732C6.16668 6.39117 6.39053 6.16732 6.66668 6.16732H9.33334Z"
        fill="#5F6477"
      />
      <path
        d="M9.33334 8.83398C9.60949 8.83398 9.83334 9.05784 9.83334 9.33398C9.83334 9.61013 9.60949 9.83398 9.33334 9.83398H6.66668C6.39053 9.83398 6.16668 9.61013 6.16668 9.33398C6.16668 9.05784 6.39053 8.83398 6.66668 8.83398H9.33334Z"
        fill="#5F6477"
      />
      <path
        d="M9.33334 11.5007C9.60949 11.5007 9.83334 11.7245 9.83334 12.0007C9.83334 12.2768 9.60949 12.5007 9.33334 12.5007H6.66668C6.39053 12.5007 6.16668 12.2768 6.16668 12.0007C6.16668 11.7245 6.39053 11.5007 6.66668 11.5007H9.33334Z"
        fill="#5F6477"
      />
    </g>
    <defs>
      <clipPath id="wometa_customer_clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M4.83333 4.00065V1.33398C4.83333 1.05784 5.05719 0.833984 5.33333 0.833984C5.60948 0.833984 5.83333 1.05784 5.83333 1.33398V4.00065C5.83333 4.27679 5.60948 4.50065 5.33333 4.50065C5.05719 4.50065 4.83333 4.27679 4.83333 4.00065Z"
      fill="#5F6477"
    />
    <path
      d="M10.1667 4.00065V1.33398C10.1667 1.05784 10.3905 0.833984 10.6667 0.833984C10.9428 0.833984 11.1667 1.05784 11.1667 1.33398V4.00065C11.1667 4.27679 10.9428 4.50065 10.6667 4.50065C10.3905 4.50065 10.1667 4.27679 10.1667 4.00065Z"
      fill="#5F6477"
    />
    <path
      d="M13.5 4.00065C13.5 3.54041 13.1269 3.16732 12.6667 3.16732H3.33333C2.8731 3.16732 2.5 3.54041 2.5 4.00065V13.334C2.5 13.7942 2.8731 14.1673 3.33333 14.1673H12.6667C13.1269 14.1673 13.5 13.7942 13.5 13.334V4.00065ZM14.5 13.334C14.5 14.3465 13.6792 15.1673 12.6667 15.1673H3.33333C2.32081 15.1673 1.5 14.3465 1.5 13.334V4.00065C1.5 2.98813 2.32081 2.16732 3.33333 2.16732H12.6667C13.6792 2.16732 14.5 2.98813 14.5 4.00065V13.334Z"
      fill="#5F6477"
    />
    <path
      d="M14 6.16732C14.2761 6.16732 14.5 6.39117 14.5 6.66732C14.5 6.94346 14.2761 7.16732 14 7.16732H2C1.72386 7.16732 1.5 6.94346 1.5 6.66732C1.5 6.39117 1.72386 6.16732 2 6.16732H14Z"
      fill="#5F6477"
    />
  </svg>
);

export const TechnicianIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M9.9605 12.3031C10.2156 12.1975 10.5085 12.3189 10.6141 12.5739C10.7197 12.8291 10.5985 13.122 10.3433 13.2276L9.72808 13.4821C9.47292 13.5877 9.18003 13.4665 9.07443 13.2113C8.96887 12.9562 9.0903 12.664 9.34526 12.5583L9.9605 12.3031Z"
      fill="#5F6477"
    />
    <path
      d="M9.07508 10.7879C9.1809 10.5329 9.47305 10.412 9.72808 10.5177L10.3433 10.773C10.5984 10.8788 10.72 11.1715 10.6141 11.4266C10.5083 11.6815 10.2155 11.8024 9.9605 11.6968L9.34526 11.4409C9.09025 11.3351 8.96933 11.043 9.07508 10.7879Z"
      fill="#5F6477"
    />
    <path
      d="M10.7879 9.07508C11.043 8.96932 11.3351 9.09024 11.4409 9.34526L11.6968 9.96049C11.8024 10.2155 11.6815 10.5083 11.4266 10.6141C11.1715 10.72 10.8788 10.5984 10.773 10.3433L10.5177 9.72807C10.412 9.47304 10.5329 9.1809 10.7879 9.07508Z"
      fill="#5F6477"
    />
    <path
      d="M10.773 13.6566C10.8787 13.4015 11.1709 13.2807 11.426 13.3864C11.681 13.4921 11.8024 13.7843 11.6968 14.0394L11.4409 14.6553C11.3352 14.9103 11.043 15.0318 10.7879 14.9261C10.5328 14.8204 10.412 14.5276 10.5177 14.2725L10.773 13.6566Z"
      fill="#5F6477"
    />
    <path
      d="M12.559 9.34526C12.6648 9.09021 12.9575 8.96924 13.2126 9.07508C13.4673 9.18099 13.5884 9.4732 13.4828 9.72807L13.2269 10.3433C13.1211 10.5983 12.8289 10.7198 12.5739 10.6141C12.3189 10.5083 12.1979 10.2155 12.3037 9.96049L12.559 9.34526Z"
      fill="#5F6477"
    />
    <path
      d="M12.5746 13.3858C12.8297 13.2805 13.1221 13.4021 13.2276 13.6572L13.4821 14.2731C13.5875 14.5282 13.4663 14.8206 13.2113 14.9261C12.9562 15.0316 12.6632 14.9104 12.5577 14.6553L12.3031 14.0388C12.1978 13.7836 12.3195 13.4912 12.5746 13.3858Z"
      fill="#5F6477"
    />
    <path
      d="M0.833336 13.9998C0.833438 13.0819 1.05038 12.177 1.46615 11.3586C1.88196 10.5401 2.48518 9.83099 3.22657 9.28955C3.96784 8.74825 4.8264 8.38969 5.73242 8.24268C6.63862 8.09568 7.56689 8.16454 8.44141 8.44385C8.70446 8.52787 8.84963 8.80906 8.76563 9.07211C8.68163 9.33511 8.40038 9.48024 8.13737 9.39633C7.41277 9.16489 6.64343 9.10786 5.89258 9.22966C5.14183 9.35147 4.43063 9.64894 3.81641 10.0975C3.20217 10.5461 2.70196 11.1329 2.35742 11.811C2.01292 12.4891 1.83344 13.2392 1.83334 13.9998C1.83331 14.276 1.60946 14.4998 1.33334 14.4998C1.05719 14.4998 0.83331 14.276 0.833336 13.9998Z"
      fill="#5F6477"
    />
    <path
      d="M14.2725 10.5177C14.5276 10.412 14.8204 10.5328 14.9261 10.7879C15.0318 11.043 14.9103 11.3352 14.6553 11.4409L14.0394 11.6968C13.7843 11.8024 13.4921 11.681 13.3864 11.4259C13.2807 11.1709 13.4015 10.8787 13.6566 10.773L14.2725 10.5177Z"
      fill="#5F6477"
    />
    <path
      d="M13.3864 12.5739C13.4922 12.3189 13.7843 12.198 14.0394 12.3037L14.6553 12.559C14.9103 12.6647 15.0317 12.9569 14.9261 13.2119C14.8204 13.467 14.5276 13.5885 14.2725 13.4828L13.6566 13.2269C13.4015 13.1212 13.2807 12.829 13.3864 12.5739Z"
      fill="#5F6477"
    />
    <path
      d="M9.5 5.33333C9.5 3.76853 8.23148 2.5 6.66667 2.5C5.10186 2.5 3.83334 3.76853 3.83334 5.33333C3.83334 6.89814 5.10186 8.16667 6.66667 8.16667C8.23148 8.16667 9.5 6.89814 9.5 5.33333ZM10.5 5.33333C10.5 7.45043 8.78376 9.16667 6.66667 9.16667C4.54958 9.16667 2.83334 7.45043 2.83334 5.33333C2.83334 3.21624 4.54958 1.5 6.66667 1.5C8.78376 1.5 10.5 3.21624 10.5 5.33333Z"
      fill="#5F6477"
    />
    <path
      d="M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
      fill="#5F6477"
    />
  </svg>
);

function MetaItem({ icon, children }) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="shrink-0 flex items-center">{icon}</span>
      <span className="text-[#5F6477] font-OpenSansRegular text-[14px] leading-5 tracking-[0.14px] truncate">
        {children}
      </span>
    </div>
  );
}

const MetaSeparator = ({ character = "•" }) => (
  <span className="text-[#B4BAD5] font-InterRegular text-[14px] leading-5 tracking-[7px]">{character}</span>
);

// `wo` is a work order as the API returns it. Anything it is missing simply
// drops out of the row along with its separator.
export default function WoMetaRow({ wo, date, technicians }) {
  if (!wo) return null;

  const number = wo.number
    ? String(wo.number).toUpperCase().startsWith("WO")
      ? String(wo.number)
      : `WO-${wo.number}`
    : "";
  const company = wo.customer?.companyName;
  const techNames =
    technicians ??
    (wo.assignedTechs || [])
      .map((tech) => tech.user?.name)
      .filter(Boolean)
      .join(", ");

  return (
    <div className="self-stretch flex items-center content-center gap-3 flex-wrap">
      {number && (
        <span className="px-[10px] py-[2px] rounded-[16px] bg-[#EEF0F9] text-[#5F6477] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
          {number}
        </span>
      )}
      <WOStatusComponent value={wo.status} />
      <MetaSeparator character="|" />
      {company && <MetaItem icon={<CustomerIcon />}>{company}</MetaItem>}
      {company && date && <MetaSeparator />}
      {date && <MetaItem icon={<CalendarIcon />}>{date}</MetaItem>}
      {date && techNames && <MetaSeparator />}
      {techNames && <MetaItem icon={<TechnicianIcon />}>{techNames}</MetaItem>}
    </div>
  );
}
